// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-6fb18b295f183c92b3ec3471d3fa1d3b","button__box":"button__box-5377825df7cbd190823b8bd30f61b5b8"};